import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import {
  TPartnerPlanExportFormats,
  TPartnerPlanPdfVersion,
} from 'legacy/lut/classes/services/partner360/ExportCommitmentService'
import { selectProgramType } from 'legacy/lut/features/partner360/configuration'
import { useJbpSettings } from 'legacy/lut/features/partner360/jbpSettings'
import { useUserRoles } from 'legacy/lut/hooks/useUserRoles'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

export interface IPartnerPlanExportOption {
  extension: TPartnerPlanExportFormats
  shouldGeneratePDFOnBackend: boolean
  /** Asks the service for a specific PDF layout; without it the service uses its default. */
  pdfVersion?: TPartnerPlanPdfVersion
}

export const usePartnerPlanExportOptions = () => {
  const programType = useSelector(selectProgramType)
  const { jbpSettings } = useJbpSettings()
  const { isP360Tester, isPartnerUser, isSuperAdmin } = useUserRoles()
  const isRetailer = programType === ProgramTypes.Retail
  const isShowJSONExport = isP360Tester || isSuperAdmin
  const isShowPdfV2Export = isSuperAdmin
  const exportOptions = useMemo<IPartnerPlanExportOption[]>(() => {
    const shouldGeneratePDFOnBackend = jbpSettings.generatePDFOnBackend === 1
    const options: IPartnerPlanExportOption[] = [
      {
        extension: 'PDF',
        shouldGeneratePDFOnBackend,
      },
    ]

    if (isShowPdfV2Export) {
      // Only the service renders the compact PDF.
      options.push({
        extension: 'PDF',
        shouldGeneratePDFOnBackend: true,
        pdfVersion: 2,
      })
    }

    if (isRetailer) {
      options.push({
        extension: 'PPTX',
        shouldGeneratePDFOnBackend: true,
      })
    }

    if (isShowJSONExport) {
      options.push({
        extension: 'JSON',
        shouldGeneratePDFOnBackend: true,
      })
    }

    return options
  }, [isRetailer, isShowJSONExport, isShowPdfV2Export, jbpSettings.generatePDFOnBackend])

  return { exportOptions, isShowDownloadPlan: isSuperAdmin, isPartnerUser }
}
